import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-card ui-mt-30" }
const _hoisted_2 = { class: "ui-card-header" }
const _hoisted_3 = { class: "ui-card-header-content" }
const _hoisted_4 = { class: "ui-header-content-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "SEO - Otimização para os buscadores")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content-button" }, null, -1)
const _hoisted_7 = { class: "ui-card-body" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_19 = { class: "ui-seo-card" }
const _hoisted_20 = { class: "ui-inline-grid" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/seo.png",
    style: {"width":"100%"}
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"position":"absolute","margin-top":"22px","margin-left":"10px"} }, "Seu conteúdo será apresentado assim")
], -1)
const _hoisted_22 = { class: "ui-seo-url" }
const _hoisted_23 = { class: "ui-seo-titulo" }
const _hoisted_24 = { class: "ui-seo-descricao" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_tooltip, { title: "SEO é a otimização para buscadores, um conjunto de técnicas para aumentar o índice de qualidade de suas páginas a partir de otimização de fatores internos e externos." }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_a_form_item, { label: "URL Amigável" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.computedEstrutura.url,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedEstrutura.url) = $event)),
                    "addon-before": 'https://' + _ctx.storeApp.state.configuracaoPlataforma.dominio
                  }, null, 8, ["value", "addon-before"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_form_item, { label: "Título" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.computedEstrutura.titulo,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedEstrutura.titulo) = $event)),
                    "show-count": "",
                    maxlength: 70
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_a_form_item, { label: "Descrição" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: _ctx.computedEstrutura.descricao,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedEstrutura.descricao) = $event)),
                    "show-count": "",
                    maxlength: 160
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_a_checkbox, {
                style: {"margin-left":"5px","margin-top":"10px"},
                checked: _ctx.computedEstrutura.indexar,
                "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedEstrutura.indexar) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Permitir que os mecanismos de busca indexem este conteúdo?")
                ]),
                _: 1
              }, 8, ["checked"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.obtemUrlSeo()), 1),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.obtemTituloSeo()), 1),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.obtemDescricaoSeo()), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}